import { render } from "./UserDetailModal.vue?vue&type=template&id=728f2eb6&scoped=true"
import script from "./UserDetailModal.vue?vue&type=script&lang=js"
export * from "./UserDetailModal.vue?vue&type=script&lang=js"

import "./UserDetailModal.vue?vue&type=style&index=0&id=728f2eb6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728f2eb6"]])

export default __exports__